var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10454",
    "data-name": "Group 10454",
    transform: "translate(-142 -1621)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    transform: "translate(142 1621)",
    fill: "#ebf8f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_graph",
    "data-name": "vuesax/outline/graph",
    transform: "translate(-133.535 1457.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph",
    transform: "translate(300 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.036,15.454H5.323c-3.535,0-5.323-2-5.323-5.962V5.418C0,3.971.17,1.9,1.675.762,2.938-.174,4.755-.245,7.438.535a11.222,11.222,0,0,1,7.481,7.481c.781,2.669.71,4.5-.227,5.749C13.556,15.284,11.484,15.454,10.036,15.454ZM4.3,2.125a2.2,2.2,0,0,0-1.334.341c-.554.412-.823,1.377-.823,2.953V9.506c0,3.18,1.221,3.833,3.194,3.833H10.05c1.561,0,2.527-.27,2.953-.823.5-.653.454-1.959-.1-3.875A9.189,9.189,0,0,0,6.87,2.608,9.013,9.013,0,0,0,4.3,2.125Z",
    transform: "translate(15.969 2.644)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M13.94,27.672A13.967,13.967,0,0,1,11.158.021a1.079,1.079,0,0,1,1.263.823A1.079,1.079,0,0,1,11.6,2.107a11.844,11.844,0,1,0,14,13.939,1.063,1.063,0,1,1,2.087.412A13.984,13.984,0,0,1,13.94,27.672Z",
    transform: "translate(1.774 4.621)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H34.068V34.068H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinIcon);
export default __webpack_public_path__ + "static/media/fin-icon.80178c44fce6bd8fc60f942efa230441.svg";
export { ForwardRef as ReactComponent };